import styled from '@emotion/styled'

export const DetailContainer = styled.div({
  display: 'flex',
})

export const Cont = styled.div(props => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
}))

export const SContDetail = styled.div(props => ({
  display: 'flex',
  marginTop: props.sub ? '0' : '1rem',
  overflowX: 'scroll',

  '&>div:first-child': {
    marginLeft: 0,
    flex: 1
  },

  '>div:first-child .toleft': {
    marginLeft: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },

  '&>div': {
    marginLeft: '1rem',
    flex: 1
  },

  '@media only screen and (min-width: 600px)': {
    overflowX: 'unset',
  },

  '@media only screen and (min-width: 769px)': {
    overflowX: 'unset',
  },
}))

export const BLContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  '@media only screen and (min-width: 600px)': {
    '.rowFields': {
      flexDirection: 'row',
    },
  },

  '@media only screen and (min-width: 769px)': {
    '.rowFields': {
      flexDirection: 'row',
    },
  },
})